module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921062649_T.d52f0c28.jpg";